import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=8e8dcada"
import script from "./Trips.vue?vue&type=script&lang=js"
export * from "./Trips.vue?vue&type=script&lang=js"
import style0 from "./Trips.vue?vue&type=style&index=0&id=8e8dcada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports